import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";


interface MyComponentProps {
  categoryLi: any,
  isActive: any;
}
const ComponentName: React.FC<MyComponentProps> = ({
  categoryLi,
  isActive,
}) => {
  const { t } = useTranslation();
  const [indexTab, setIndexTab] = React.useState(-1);
  const navigate = useNavigate()
  const token = useSelector((state: any) => state?.token)
  return (
    <div className={`${isActive ? 'block' : 'hidden'}`}>
      <div className="text-[#181512] text-[18px]  px-[0px] pt-[20px] cursor-pointer relative group">
        <div className="flex items-center justify-between pb-10"
          onClick={() => setIndexTab(indexTab === 0 ? -1 : 0)}
          style={{
            borderBottom: '1px solid #dcdcdca3'
          }}>
          瀏覽商品
          <img src={require("../assets/image/icon1.png")}
            className={`w-[12px] h-[12px] rotate-90 ml-2 transition-transform duration-300 ease-in-out 
          ${indexTab === 0 ? 'rotate-[-90deg]' : ''}`} alt="" />
        </div>
        <div className={`bg-white py-10 ${indexTab === 0 ? 'block' : 'hidden'} transition-all duration-300`}
        >
          {
            categoryLi.map((item: any, index: number) => {
              return (
                <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
                  key={index}
                  onClick={() => {
                    navigate('/category' + '?id=' + item?.id)
                    window.location.reload()
                  }
                  }
                  style={{
                    borderBottom: '1px solid #dcdcdca3'
                  }}>{item?.showName}</div>
              )
            })
          } 
        </div>
      </div>
      <div className="text-[#181512] text-[18px]  px-[0px] pt-[20px] cursor-pointer relative group">
        <div className="flex items-center justify-between pb-10"
          style={{
            borderBottom: '1px solid #dcdcdca3'
          }}
          onClick={() => {
            navigate('/exhibit')
          }}>
          詩肯概念展示
        </div>
      </div>
      <div className="text-[#181512] text-[18px]  px-[0px] pt-[20px] cursor-pointer relative group">
        <div className="flex items-center justify-between pb-10"
          onClick={() => {
            navigate('/scenes')
          }
          }
          style={{
            borderBottom: '1px solid #dcdcdca3'
          }}>
          活動花絮
        </div>
      </div>
      <div className="text-[#181512] text-[18px]  px-[0px] pt-[20px] cursor-pointer relative group">
        <div className="flex items-center justify-between pb-10"
          onClick={() => setIndexTab(indexTab === 3 ? -1 : 3)}
          style={{
            borderBottom: '1px solid #dcdcdca3'
          }}>
          關於詩肯
          <img src={require("../assets/image/icon1.png")}
            className={`w-[12px] h-[12px] rotate-90 ml-2 transition-transform duration-300 ease-in-out 
          ${indexTab === 3 ? 'rotate-[-90deg]' : ''}`} alt="" />
        </div>
        <div className={`bg-white py-10 ${indexTab === 3 ? 'block' : 'hidden'} transition-all duration-300`}
        >
          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              navigate('/about/history')
            }
            }
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>詩肯歷史</div>
          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              navigate('/about/news')
            }
            }
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>報道專區</div>
          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              navigate('/about/videos')
            }
            }
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>影音專區</div>
          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              navigate('/about/whyUs')
            }
            }
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>選擇詩肯</div>
        </div>
      </div>
      <div className="text-[#181512] text-[18px]  px-[0px] pt-[20px] cursor-pointer relative group">
        <div className="flex items-center justify-between pb-10"
          onClick={() => setIndexTab(indexTab === 4 ? -1 : 4)}>
          會員中心
          <img src={require("../assets/image/icon1.png")}
            className={`w-[12px] h-[12px] rotate-90 ml-2 transition-transform duration-300 ease-in-out 
          ${indexTab === 4 ? 'rotate-[-90deg]' : ''}`} alt="" />
        </div>
        <div className={`bg-white py-10 ${indexTab === 4 ? 'block' : 'hidden'} transition-all duration-300`}
        >
          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              navigate('/faq')
            }
            }
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>常見問題</div>

          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              if (token) {
                navigate('/account/accountMemberLevels')
              } else {
                window.open('https://tawk.to/chat/6998a0174d62fa1c365da542/1jhu32na5', '_blank')
              }
            }}
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>會員等級說明</div>
          <a href="https://tawk.to/chat/6998a0174d62fa1c365da542/1jhu32na5" target="_blank" rel="noopener noreferrer">
            <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
              style={{
                borderBottom: '1px solid #dcdcdca3'
              }}>聯絡我們</div>
          </a>
          <div className="text-[#181512] text-[18px] px-20 py-[10px] cursor-pointer"
            onClick={() => {
              navigate('/promotion')
            }
            }
            style={{
              borderBottom: '1px solid #dcdcdca3'
            }}>重要公告</div>
        </div>
      </div>
    </div>
  );
};

export default ComponentName;
